export default function diagnosticTestsShop(prices) {
    return {
        prices: [],
        quantities: [],
        totalPrice: 0,
        totalQuantity: 0,
        clinicId: null,
        init() {
            this.prices = prices.map((price) => parseFloat(price));
            this.quantities = prices.map(() => 0);
            this.$watch('quantities', () => {
                const { quantity, price } = this.prices.reduce(
                    (prev, curr, index) => ({
                        quantity: prev.quantity + this.quantities[index],
                        price: prev.price + this.quantities[index] * this.prices[index],
                    }),
                    { quantity: 0, price: 0 }
                );
                this.totalQuantity = quantity;
                this.totalPrice = price;
            });
        },
    };
}
